<script setup lang="ts">
  import Icon from '../Icon/Icon.vue'

  const { t } = useI18n()
  const isOpen = ref(false)

  const toggle = () => {
    isOpen.value = !isOpen.value
  }
  const hide = () => {
    isOpen.value = false
  }

  // handling the enter and space on tab accessibility
  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      toggle()
    }
  }
</script>
<template>
  <div v-click-outside="hide" class="relative">
    <div
      tabindex="0"
      class="flex visited:no-underline hover:underline cursor-pointer flex-row items-center gap-2 p-0"
      data-testid="settings-button"
      @click="toggle"
      @keydown="handleKeydown"
    >
      <slot name="button">
        <Icon icon="settings" classes="h-14px w-14px" />
        <Typography color="text-content-secondary" variant="text-[13px]">
          {{ t('Settings') }}
        </Typography>
      </slot>
    </div>
    <SettingsPopover :is-open="isOpen" />
  </div>
</template>
